export default __webpack_public_path__ + "static/media/solider.e3a199e9.png";